<!-- <script>
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', 'G-9BDRPL75R9');
</script> -->
<script>
  import { onMount } from 'svelte';
  import gtag from 'gtag';
  onMount(() => {
    gtag('config', 'G-9BDRPL75R9', {
      page_title: 'Home',
      page_path: '/home',
    });
  });
</script>
